<template>
  <div class="server" :style="{ 'background-image': `url(${image_url})` }">
    <div class="server_container">
        <div class="left_title">
            <img :src="icon_url" alt="" style="">
            <div class="line"></div>
            <p class="title_p1">{{ small_title.en }}</p>
            <p class="title_p2">{{ small_title.ch }}</p>
        </div>
        <div class="right_title">
            <p style="color: #54d1ef; font-size: 3.5rem; font-weight: 600; letter-spacing: 0.5rem; margin-bottom: 10%;">{{ big_title.title }}</p>
            <p style="color: rgb(200, 200, 200); font-size: 1rem; line-height: 2;">{{ big_title.content }}</p>
            <el-button
                @click="goAbout"
                style="margin-top: 5%; margin-left: 88%; border-radius: 2rem; background-color: #54d1ef; color: #fff; border: none;">预约产品演示</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { digitalPreview } from '../../util/constant'
export default {
    data(){
        return{
        }
    },
    props:{
        image_url:String,
        icon_url:String,
        small_title:Object,
        big_title:Object
    },
    methods:{
        goAbout(){
            window.open('http://pongo.net.cn/about#contact', '_blank')
            // window.open('http://localhost:8080/about#contact', '_blank')
        }
    }
}
</script>

<style lang="less" scoped>
.server{
    width: 100%;
    // height: 500px;
    background-color: #000;
    background-size: cover;
    .server_container{
        margin: 0 auto;
        height: 100%;
        color: #fff;
        display: flex;
        padding-top: 10rem;
        padding-bottom: 10rem;
        .left_title{
            width: 40%;
            height: 30%;
            margin: auto;
            padding: 0 5% 0 8%;
            .line{
                border-bottom: 1px #fff solid;
                width: 33%;
                margin: 4% 0;
            }
            .title_p1{
                margin: 4% 0;
            }
            .title_p2{
                margin-top: 5%;
                font-size: 0.9rem;
            }
        }
        .right_title{
            // background-color: coral;
            width: 60%;
            height: 50%;
            margin: auto;
            padding: 0 5% 0 5%;
        }
    }
    // @media screen and (min-width: 1024px) {
    //     .server_container{
    //         width: 1200px;
    //     }
    // }
    // @media screen and (min-width: 1680px) {
    //     .server_container{
    //         width: 1350px;
    //     }
    // }
}
</style>